import { Validators } from "@angular/forms";
import { IDivision } from "@app/shared/data-access/src/lib/resource-management/models/division";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
  IHardFormSelectParams,
} from "@app/shared/ui-lib/src/lib";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { IFleetAccessible } from "@dmms/shared/data-access/resource-management/models/fleet";

export class DivisionConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.Division;
  isCrudByModal = true;
  title = "dicTable.divisions";

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      name: "code",
      title: "dicTable.code",
      type: HardFormFieldTypeEnum.Input,
      params: {
        validators: [Validators.required],
      },
    },
    {
      name: "fleets",
      title: "dicTable.fleets",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + ResourceManagementEndpoints.FleetAccessible,
        multiple: true,
      } as IHardFormSelectParams,
    },
    {
      title: "dicTable.sortOrder",
      name: "sortOrder",
      type: HardFormFieldTypeEnum.Number,
    },
  ];

  saveCallback(data: IDivision): IDivision {
    const fleetIds = data?.fleets?.map((item) => item?.id) ?? [];

    delete data?.fleets;

    return {
      ...data,
      fleetIds,
    };
  }

  filterTemplateColumns = "1fr 220px";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
    {
      name: "fleet",
      type: HardFormFieldTypeEnum.Dictionary,
      params: {
        dicType: "api/v1/" + ResourceManagementEndpoints.FleetAccessible,
      } as IHardFormSelectParams,
      placeholder: "base.allFleets",
      outside: true,
    },
  ];

  filterCallback(data: { searchTerm: string; fleet: IFleetAccessible }): {
    searchTerm: string;
    fleetId: string | null;
  } {
    return {
      searchTerm: data?.searchTerm ?? "",
      fleetId: data?.fleet?.id ?? null,
    };
  }

  tableConfig: ITable<IDivision[]> = {
    showDefaultActions: true,
    tableColumns: "40px repeat(3,auto)",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "dicTable.code",
        name: "code",
        type: HardTableColumnTypeEnum.Text,
      },
    ],
  };
}
